import { join } from 'node:path';
import { copyFile, ensureDir, isDir, listFiles, fileBasename } from '../lib/fs-utils.js';
import type { SyncContext, SectionResult } from './types.js';

/**
 * Section 2i: Windsurf/Windsurf workflow files.
 *
 * Workflows live under sdlc/files/_common/workflows/*.md. Each is a
 * slash-command workflow (YAML frontmatter + markdown steps) that
 * consumers invoke from their IDE (e.g. /devaudit-update-install).
 * They sync to the consumer's .devin/workflows/.
 */
export async function syncWorkflows(ctx: SyncContext): Promise<SectionResult> {
  const src = join(ctx.installerRoot, 'sdlc', 'files', '_common', 'workflows');
  if (!(await isDir(src))) {
    return { name: 'Workflows', filesSynced: 0, skipped: true };
  }
  // Devin reads .devin/workflows/ from the repo root. See #689 follow-up.
  const dst = join(ctx.repoRoot, '.devin', 'workflows');
  await ensureDir(dst);
  const files = await listFiles(src, (n) => n.endsWith('.md'));
  const filePaths: string[] = [];
  for (const file of files) {
    const out = join(dst, fileBasename(file));
    await copyFile(file, out);
    filePaths.push(out);
  }
  return {
    name: 'Workflows',
    filesSynced: files.length,
    message: files.length > 0 ? `synced to .devin/workflows/` : 'no workflow files found',
    filePaths,
  };
}
